<style lang="scss" scoped>
main {
  width: calc(100% - 65px);
  background-color: transparent;
  border: none;
  border-radius: 0;
  padding: 2rem 1rem 1rem 0;
}
</style>

<template>
  <div class="organization-page">
    <NavBar />
    <div class="org-main-wrapper">
      <SideBar />
      <main>
        <div class="container-fluid main-content" :class="{ active: rightSidebarActive }">
          <slot />
          <task-detail v-if="showModal" />
        </div>
      </main>
    </div>

    <sidebar-right :rightSidebarActive="rightSidebarActive" @toggle-sidebar="toggleSidebar"> <sidebar-item />
    </sidebar-right>
    <Footer />
  </div>
</template>

<script>
import SidebarRight from "@c/sidebar-right.vue";
import Footer from "./footer";
import NavBar from "./header";
import sidebarItem from "./organization-sidebar-right-item.vue";
import SideBar from "./side-bar";

export default {
  components: { NavBar, SideBar, Footer, SidebarRight, sidebarItem },
  data() {
    return {
      rightSidebarActive: false,
    };
  },
  computed: {
    isMenuCollapsed() {
      return this.$store.getters["layout/isMenuCollapsed"];
    },
    showModal() {
      return true; // TKP-146: yol haritası sayfası kalktı; eski "yol haritasında modal gösterme" istisnası yok
    },
  },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
  },
  methods: {
    toggleSidebar() {
      this.rightSidebarActive = !this.rightSidebarActive;
    },
    toggleMenu() {
      if (this.isMenuCollapsed) {
        document.body.classList.remove("vertical-collpsed");
      } else {
        document.body.classList.add("vertical-collpsed");
      }
      this.$store.dispatch("layout/toggleMenuCollapse");
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    if (this.isMenuCollapsed) {
      document.body.classList.add("vertical-collpsed");
    } else {
      document.body.classList.remove("vertical-collpsed");
    }
  },
};
</script>
